module.exports = __webpack_public_path__ + "img/icon-input-clear.4ee40616.svg";